import { NgModule } from '@angular/core';
import { DialogComponent } from './dialog.component';

@NgModule({
  imports: [],
  declarations: [
    DialogComponent
  ],
  providers: [],
  exports: [
    DialogComponent
  ]
})
export class DialogModule { }
